<template>
    <div v-if="!reverse">
        <label class="pr-1" v-if="label" :for="name" @click="toggle()">
            <span class="text-sm font-bold text-gray-900">
                {{ label }}
            </span>
        </label>
        <input
            type="checkbox"
            :name="name"
            :value="value"
            :disabled="disabled"
            v-model="model"
            class="rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-1 focus:ring-indigo-500"
        />
    </div>
    <div v-else>
        <input
            type="checkbox"
            :name="name"
            :value="value"
            :disabled="disabled"
            v-model="model"
            class="rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-1 focus:ring-indigo-500"
        />
        <label class="pl-1" v-if="label" :for="name" @click="toggle()">
            <span class="text-sm font-bold text-gray-900">
                {{ label }}
            </span>
        </label>
    </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['update:checked']);

const props = defineProps<{
    name: string;
    checked?: boolean;
    value?: any;
    label?: string;
    reverse?: boolean;
    disabled?: boolean;
}>();

const model = defineModel<boolean>({ required: true });

function toggle() {
    model.value = !model.value;
}
</script>
